import { combineReducers } from 'redux'

import carWheelPackage from './CarWheelPackageSearch/carWheelPackageSearchSlice'
import premadeWheelPackage from './PremadeWheelPackageSearch/premadeWheelPackageSearchSlice'

export default combineReducers({
	carWheelPackage,
	premadeWheelPackage,
})